import {
  AccordionIconButton,
  CollapseTrigger as VaporCollapseTrigger,
} from '@frameio/vapor';
import TEXT from './generated/TEXT/CollapseTrigger';

type CollapseTriggerProps = {
  isExpanded: boolean;
};

export const CollapseTrigger = ({ isExpanded }: CollapseTriggerProps) => {
  return (
    <VaporCollapseTrigger>
      <AccordionIconButton
        data-testid="workspace-tree-item--chevron"
        isExpanded={isExpanded}
        label={isExpanded ? TEXT.collapseWorkspace : TEXT.expandWorkspace}
        size="small"
      />
    </VaporCollapseTrigger>
  );
};

TEXT.DEFINE({
  /** Aria label for expand workspace button */
  expandWorkspace: 'Expand workspace',
  /** Aria label for collapse workspace button */
  collapseWorkspace: 'Collapse workspace',
});
